module.exports = __webpack_public_path__ + "iconGray.webp?c859dcb877da07ac6b0c9068be7152a1";